import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {AbstractControl, FormControl, FormGroup, Validators} from "@angular/forms";
import {EvkOption, MessageCrudService} from "@evomatik/evk-common";
import {BehaviorSubject, combineLatest, forkJoin, Observable, of, Subject} from "rxjs";
import {ExpedienteCreateService} from "../../../expediente/services/expediente-create.service";
import {filter, map, startWith, take} from "rxjs/operators";
import {TareaDocumentoConsultasService} from "../../services/tarea-documento-consultas.service";
import {EvkDiligenciaConfigModel} from "../../models/diligencia-config.model";
import {EvkExpedienteConfigModel} from "../../../expediente/models/evk-expediente-config.model";
import {EvkExpedienteModel} from "../../../expediente/models/evk-expediente.model";
import {TipoExpedienteEnum} from "../../../expediente/enums/tipo-expediente-enum";
import { EvkDefaultValuesStorageService } from '@evomatik/evk-forms';

@Component({
  selector: 'lib-tarea-documento-create',
  templateUrl: './tarea-documento-create.component.html',
  styleUrls: ['./tarea-documento-create.component.css']
})
export class TareaDocumentoCreateComponent implements OnInit {

    @Output()
    agregarExpediente: EventEmitter<any> = new EventEmitter<any>();

    @Output()
    regresar: EventEmitter<any> = new EventEmitter<any>();

    @Output()
    catalogosCargados: EventEmitter<boolean> = new EventEmitter();

    form: FormGroup = new FormGroup({});
    expedientesOptions: EvkOption[] = [];
    expedienteFilteredOptions$: Observable<EvkOption[]>;
    diligenciaOptions = [];
    diligenciaFilteredOptions$: Observable<any[]>;

    expediente: EvkExpedienteModel = new EvkExpedienteModel();
    configExpediente: EvkExpedienteConfigModel = new EvkExpedienteConfigModel();
    idDiligenciaConfig: string;

    constructor(
        public messageCrudService: MessageCrudService,
        public tareaDocumentoConsultasService: TareaDocumentoConsultasService,
        public expedienteCreateService: ExpedienteCreateService,
        private valuesStorageService: EvkDefaultValuesStorageService,
    ) {
    }

    ngOnInit(): void {
        this.cargaCatalogos();
        this.eventHandlerEventInit();
        this.buildForm(this.form);
    }

    cargaCatalogos() {
        const requests = [];
        requests.push(this.tareaDocumentoConsultasService.getExpedientesByTipo(TipoExpedienteEnum.DEMO));
        requests.push(this.tareaDocumentoConsultasService.getTipoDiligencias());
        forkJoin(requests).subscribe((
            [res1, res2]:
                [EvkOption[], EvkDiligenciaConfigModel[]]
        ) => {
            this.expedientesOptions = res1;
            res2.forEach(element => {
                this.diligenciaOptions.push(this.buildOption(element, 'nombre'));
            });
            this.catalogosCargados.emit(true);
        });
    }

    eventHandlerEventInit() {
        this.catalogosCargados.subscribe((res) => {
            if (res) {
                this.expedienteFilteredOptions$ = this.filterOptions(this.form.controls.expediente, of(this.expedientesOptions));
                this.diligenciaFilteredOptions$ = this.filterOptions(this.form.controls.diligencia, of(this.diligenciaOptions));
            }
        });
    }

    onChangeSelectExpediente(event) {
        console.log('Expediente', event);
        if (event) {
            this.expediente.idExpediente = event.value;
        }
    }

    onSelectDiligencia(event) {
        console.log('Diligencia: ', event)
        if (event) {
            this.idDiligenciaConfig = event.id;
            this.configExpediente.nombre = event.configuracionExpediente.label;
            this.configExpediente.id = event.configuracionExpediente.value;
        }
    }

    continuar() {
        this.expediente.configuracionExpediente = this.configExpediente;
        this.expediente.idDiligenciaConfig = this.idDiligenciaConfig;
        this.expediente.enviadaComoRespuesta = false;
        this.expedienteCreateService.save(this.expediente).pipe(take(1)).subscribe(
            (response) => {
                this.expediente = response.data;
                this.expediente.idDiligenciaConfig = this.idDiligenciaConfig;
                this.expediente.idDiligenciaPadre = this.idDiligenciaConfig;
                this.agregarExpediente.emit(this.expediente);
            }, () => {
                this.messageCrudService.snackbarMessage('No se ha podido guardar');
            }
        );
    }

    goBack() {
        this.regresar.emit();
    }

    buildForm(form?: FormGroup) {
        form.addControl('expediente', new FormControl(null, Validators.required));
        form.addControl('diligencia', new FormControl(null, Validators.required));
    }

    buildOption(data: any, labelProp: string): any {
        const label = data[labelProp];
        return {
            label: label,
            value: data['id'],
            active: data['activo'],
            configuracionExpediente: data['configuracionExpediente'],
            id: data['id']
        };
    }

    filterOptions = (formControl: FormControl | AbstractControl, opciones$: Observable<EvkOption[]>, valueChanges?: Observable<any> | Subject<any> | BehaviorSubject<any>) => {
        const valueChanges$ = valueChanges ? valueChanges : formControl.valueChanges;
        return combineLatest(
            [
                valueChanges$.pipe(startWith('')),
                opciones$
            ]
        ).pipe(
            filter(([value, _]) => typeof value === 'string'
            ),
            map(([name, opciones]) => name ? this._filter(name, opciones) : opciones.slice())
        );

    }

    _filter(label: string, options: EvkOption[]): EvkOption[] {
        const filterValue = this.removeAccents(label.toLowerCase());
        return options.filter(
            option =>
                this.removeAccents(option.label.toLowerCase()).indexOf(filterValue) !== -1);
    }

    removeAccents = (str) => {
        return str.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
    }

    displayFn = (option) => (option && option.label) ? option.label : '';

}
